import { Button } from '@design-system';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';

import { useDrawButtonLabels } from '../../features/draws/hooks/useDrawButtonLabels';
import { DrawByProductId } from '../../features/draws/types';
import { useIsPreOrder } from '../../hooks/useIsPreOrder';
import { useAuth } from '../../providers';

interface Props {
  /** Rendered in the bottom sticky bar, where the button is always 44px. */
  bottomBar?: boolean;
  draw: DrawByProductId;
  fullWidth?: boolean;
  isAuction?: boolean;
  isMobile: boolean;
  onClick: (isPreOrder: boolean) => void;
}

export const DrawStickyButtons: FC<Props> = ({
  bottomBar = false,
  draw,
  fullWidth = false,
  isAuction,
  isMobile,
  onClick,
}) => {
  const { isLoggedIn } = useAuth();
  const { t } = useTranslation('product');

  const isPreOrder = useIsPreOrder(draw);
  const labels = useDrawButtonLabels(
    'stickyCta',
    isPreOrder,
    isMobile,
    isAuction,
  );

  const entered = Boolean(draw.accountIsInDraw);
  const active = isLoggedIn && entered;

  return (
    <Button
      fullWidth={fullWidth}
      icon={active ? 'ic_check' : undefined}
      label={t(active ? labels.success : labels.normal)}
      onClick={() => onClick(isPreOrder)}
      size={bottomBar ? 'md' : isMobile ? 'sm' : 'md'}
      variant={active ? 'positive' : 'primary'}
    />
  );
};
